// filepath: apps/web/src/features/admin/hmacKeys/HmacKeysRoute.tsx
//
// FR-UI-ADM-7 AC-13 — route shell for the HMAC key rotation action.
//
// URL: /admin/webhooks/keys
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403). The page mounts HmacKeysPage which consumes the
// existing 4 backend endpoints from FR-EVT-9.

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { HmacKeysPage } from "./HmacKeysPage";

interface HmacKeysRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function HmacKeysRoute({
  environmentKind,
}: HmacKeysRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <HmacKeysPage environmentKind={environmentKind} />;
}
